import { render } from "./TPCommonButtonList.vue?vue&type=template&id=8f0bc854&scoped=true&ts=true"
import script from "./TPCommonButtonList.vue?vue&type=script&lang=ts"
export * from "./TPCommonButtonList.vue?vue&type=script&lang=ts"

import "./TPCommonButtonList.vue?vue&type=style&index=0&id=8f0bc854&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f0bc854"]])

export default __exports__